import "./App.css"

import { QueryErrorResetBoundary } from "@tanstack/react-query"
import React, { useEffect, useState, useRef } from "react"
import { RouterProvider, createBrowserRouter } from "react-router-dom"

import { refreshToken } from "./AuthConfig"
import { GlobalContextProvider } from "./context/GlobalContext"
import { DarkModeProvider } from "./context/DarkModeContext"
import RoutesConfig from "./routes/RoutesConfig"
import { useGetRefreshToken } from "./services/queries"
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "./components/ErrorBoundary"
const App = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false)
    const router = createBrowserRouter(RoutesConfig)
    const [enabled, setEnabled] = useState(false)
    const { data: refreshTokenData } = useGetRefreshToken(enabled)
    let userDetails = sessionStorage.getItem("userDetails")
    let userType = JSON.parse(userDetails)?.user_details
    const initialized = useRef(false)
    const externalAuth = async () => {
        setEnabled(true)
    }

    const refreshTokenHandler = () => {
        if (userType?.user_type == 2) {
            const checkAuth = async () => {
                let token = sessionStorage.getItem("access_token")
                token = await refreshToken()
                setIsAuthenticated(!!token)
            }
            checkAuth()
            const interval = setInterval(refreshToken, 210000)
            return () => clearInterval(interval)
        } else if (userType?.user_type == 1) {
            setEnabled(true)
            const interval = setInterval(externalAuth, 3420000)
            return () => clearInterval(interval)
        }
    }

    useEffect(() => {
        if (!initialized.current) {
            initialized.current = true
            refreshTokenHandler()
        }
    }, [])
    useEffect(() => {
        if (refreshTokenData?.mfaTokenData) {
            sessionStorage.setItem("id_token", refreshTokenData?.mfaTokenData?.access_token)
        }
    }, [refreshTokenData?.mfaTokenData])
     window.onerror = function (message, source, lineno, colno, error) {
            console.log(
                "Global error caught:",
                {
                    message,
                    source,
                    lineno,
                    colno,
                    error
                }
            );
            
             if(message !== ""){
                window.location.href = `/error-boundary?msg=${encodeURIComponent(message)}`
                //navigate("/error-boundary")
            }
            // Prevent the default browser error overlay
            return true;
        };
    return (        
        <QueryErrorResetBoundary>
            <DarkModeProvider>
                <GlobalContextProvider>
                        <ErrorBoundary
                            FallbackComponent={ErrorFallback}
                            onReset={() => {
                                window.location.reload();
                            }}
                        >
                        <RouterProvider router={router} />
                    </ErrorBoundary>
                </GlobalContextProvider>
            </DarkModeProvider>
        </QueryErrorResetBoundary>        
    )
}

export default App
